import { styled } from "@pigment-css/react";
import { GlassButton } from "@acto/taskpane/field-sales-2/components/primitives/GlassButton";

const ErrorBlock = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.fieldSalesTwo.spacing[16],
  padding: `${theme.fieldSalesTwo.spacing[24]} 0`,
  textAlign: "center",
}));

const ErrorText = styled("p")(({ theme }) => ({
  margin: 0,
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size["15"],
  fontWeight: theme.fieldSalesTwo.font.weight["500"],
  lineHeight: theme.fieldSalesTwo.font.lineHeight["148"],
  color: theme.fieldSalesTwo.colors.neutral[700],
}));

const RetryButton = styled(GlassButton)(({ theme }) => ({
  color: theme.fieldSalesTwo.colors.neutral[800],
}));

interface TodoSectionErrorProps {
  /** Already translated by the caller. */
  message: string;
  retryLabel: string;
  onRetry: () => void;
  /** Disables the button while the retry is in flight. */
  isRetrying?: boolean;
}

/** A bucket's own load failure, whether its first page or a later one failed. */
export function TodoSectionError({ message, retryLabel, onRetry, isRetrying = false }: TodoSectionErrorProps) {
  return (
    <ErrorBlock role="alert">
      <ErrorText>{message}</ErrorText>
      <RetryButton type="button" onClick={onRetry} disabled={isRetrying} aria-busy={isRetrying || undefined}>
        {retryLabel}
      </RetryButton>
    </ErrorBlock>
  );
}
